import gql from 'graphql-tag';
import { PeriodPlanResultFields } from './fragments/PeriodPlanResult';

export default function(uniqKey = '') {
  const key = 'getPeriodPlanResult' + uniqKey;
  return {
    key,
    query: gql`

  query ${key} ($memberId: ID!, $periodId: ID!) {
    getMember(id: $memberId) {
      id #dont remove this field, else it will return empty 
      planResults(
        filter: {
          periodPlanResultPeriodId: { eq: $periodId }
        }
        sortDirection: DESC
      ) {
        items {
          ${PeriodPlanResultFields}
        }
      }
    }
  }

  `,
  };
}
